export default __webpack_public_path__ + "media/blackberries-large.bdcc751f7f2f49ed3c1907459248db59.webp";